// @generated by protoc-gen-es v1.10.1
// @generated from file rbt/cloud/v1alpha1/user/user.proto (package rbt.cloud.v1alpha1.user, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp, Value } from "@bufbuild/protobuf";
import { TaskId } from "../../../v1alpha1/tasks_pb.js";

/**
 * @generated from message rbt.cloud.v1alpha1.user.SurveyData
 * @deprecated
 */
export const SurveyData = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.SurveyData",
  () => [
    { no: 1, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "company_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "preferred_programming_languages", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "use_case", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "about_yourself", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.User
 */
export const User = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.User",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(User_Status) },
    { no: 4, name: "signup_mailgun_message_id_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "activation_mailgun_message_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "api_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "organization_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "api_key_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "last_selected_organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from enum rbt.cloud.v1alpha1.user.User.Status
 */
export const User_Status = /*@__PURE__*/ proto3.makeEnum(
  "rbt.cloud.v1alpha1.user.User.Status",
  [
    {no: 0, name: "WAITLIST"},
    {no: 1, name: "ACTIVE"},
    {no: 2, name: "INACTIVE"},
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.Users
 */
export const Users = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.Users",
  () => [
    { no: 1, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.AddRequest
 */
export const AddRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.AddRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.AddResponse
 */
export const AddResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.AddResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.UsersGetRequest
 */
export const UsersGetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.UsersGetRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.UsersGetResponse
 */
export const UsersGetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.UsersGetResponse",
  () => [
    { no: 1, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.InvalidInputError
 */
export const InvalidInputError = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.InvalidInputError",
  () => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.UserSetClaimsRequest
 */
export const UserSetClaimsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.UserSetClaimsRequest",
  () => [
    { no: 1, name: "claims", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Value} },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.SignUpRequest
 */
export const SignUpRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.SignUpRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.SignUpResponse
 */
export const SignUpResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.SignUpResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.SetSurveyDataRequest
 * @deprecated
 */
export const SetSurveyDataRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.SetSurveyDataRequest",
  () => [
    { no: 1, name: "survey_data", kind: "message", T: SurveyData },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.SetSurveyDataResponse
 * @deprecated
 */
export const SetSurveyDataResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.SetSurveyDataResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.SetStatusRequest
 */
export const SetStatusRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.SetStatusRequest",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(User_Status) },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.SetStatusResponse
 */
export const SetStatusResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.SetStatusResponse",
  () => [
    { no: 3, name: "activate_task_id", kind: "message", T: TaskId, opt: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.ActivateResponse
 */
export const ActivateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.ActivateResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.GetRequest
 */
export const GetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.GetRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.GetResponse
 */
export const GetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.GetResponse",
  () => [
    { no: 1, name: "user_state", kind: "message", T: User },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.AddToOrganizationRequest
 */
export const AddToOrganizationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.AddToOrganizationRequest",
  () => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.AddToOrganizationResponse
 */
export const AddToOrganizationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.AddToOrganizationResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.RemoveFromOrganizationRequest
 */
export const RemoveFromOrganizationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.RemoveFromOrganizationRequest",
  () => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.RemoveFromOrganizationResponse
 */
export const RemoveFromOrganizationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.RemoveFromOrganizationResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.SetLastSelectedOrganizationRequest
 */
export const SetLastSelectedOrganizationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.SetLastSelectedOrganizationRequest",
  () => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.SetLastSelectedOrganizationResponse
 */
export const SetLastSelectedOrganizationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.SetLastSelectedOrganizationResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.CreateAPIKeyRequest
 */
export const CreateAPIKeyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.CreateAPIKeyRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.CreateAPIKeyResponse
 */
export const CreateAPIKeyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.CreateAPIKeyResponse",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.DeleteAPIKeyRequest
 */
export const DeleteAPIKeyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.DeleteAPIKeyRequest",
  () => [
    { no: 1, name: "api_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.DeleteAPIKeyResponse
 */
export const DeleteAPIKeyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.DeleteAPIKeyResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.GetAPIKeysForOrganizationRequest
 */
export const GetAPIKeysForOrganizationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.GetAPIKeysForOrganizationRequest",
  () => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.APIKeyView
 */
export const APIKeyView = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.APIKeyView",
  () => [
    { no: 1, name: "api_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.user.GetAPIKeysForOrganizationResponse
 */
export const GetAPIKeysForOrganizationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.user.GetAPIKeysForOrganizationResponse",
  () => [
    { no: 1, name: "api_keys", kind: "message", T: APIKeyView, repeated: true },
  ],
);

